import React from "react";
import { Seo } from "../components/Seo";
import { SEO } from "../seo";
import { GuideHub } from "../components/GuideHub";

export default function GuidePage() {
  return (
    <div className="pt-10">
      <Seo {...SEO.guide} />
      <GuideHub />
    </div>
  );
}
